import { Suspense } from "react";
import { RouterProvider } from "react-router-dom";
import AppProviders from "./context/AppContext";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./lib/queryClient";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import type { IPublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import Auth from "./Auth";
import { ThemeProvider } from "@emotion/react";
import { CssBaseline } from "@mui/material";
import router from "./router";
import LoadingOverlay from "./components/LoadingOverlay";
import globaltheme from "./styles/globaltheme";
import { validateEnv } from "./utils/env-validation";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

export default function App(props: { pca: IPublicClientApplication }) {
  const { pca } = props;

  validateEnv();

  return (
    <MsalProvider instance={pca}>
      <QueryClientProvider client={queryClient}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
        <ThemeProvider theme={globaltheme}>
          <CssBaseline />
          <Auth />
          <AppProviders>
            <Suspense fallback={<LoadingOverlay />}>
              <RouterProvider router={router} />
            </Suspense>
            <LoadingOverlay />
          </AppProviders>
        </ThemeProvider>
        <ReactQueryDevtools initialIsOpen={false} position="bottom" />
      </LocalizationProvider>
      </QueryClientProvider>
    </MsalProvider>
  );
}
